exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".price-tag[data-v-dc7a14d2]{font-size:18px}.price-tag del[data-v-dc7a14d2]{color:red}.custom-qty[data-v-dc7a14d2]{display:inline-flex}.increase.items[data-v-dc7a14d2],.reduced.items[data-v-dc7a14d2]{background:#ddd;border:1px solid #ddd;color:#222;padding:8px 10px 7px;float:left;cursor:pointer}.input-text.qty[data-v-dc7a14d2]{border:1px solid #ddd;max-width:50px;padding:4px 13px;float:left;text-align:center;margin:0 -1px}.card-header>.nav .nav-link.active[data-v-dc7a14d2]{font-weight:700}", ""]);

// exports
